module.exports = __webpack_public_path__ + "static/media/care-aid.03f663ac.png";